import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import TicketReturnEditor from "../Common/TicketReturnEditor";
import POSHeader from "./POSHeader";
import { shiftActions } from "../../sagas/shiftSlice";
import { POS_PAGE, CPMT_STOCK_PAGE, CPMT_PRODUCTS_PAGE, PAY_PAGE, RETOUR_FORM_NEW, RETOUR_PAGE, CPMT_RECEPTION_PAGE } from "../../routes/routeConstants";
import "./CustomerReturnFormPOS.css";

export default function CustomerReturnForm({ customerReturn: suppliedReturn, onClose }) {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const customerReturn = onClose ? suppliedReturn : location.state?.customerReturn;
    const { currentShift } = useSelector(state => state.shift);
    const { businessName, commercialId, pointOfSaleId, fullName } = useSelector(state => state.auth);
    const destinations = { VENTES: POS_PAGE, STOCK: CPMT_STOCK_PAGE, PRODUCTS: CPMT_PRODUCTS_PAGE, AVANCE: PAY_PAGE, RETOURS: RETOUR_FORM_NEW, RECEPTION: CPMT_RECEPTION_PAGE };
    return <Container fluid className={onClose ? "p-0" : "pos-form-page"}>
        {!onClose && <POSHeader businessName={businessName || "MATJARPOS"} commercialId={commercialId} pointOfSaleId={pointOfSaleId} fullName={fullName} activeTab="RETOURS" onChangeTab={tab => destinations[tab] && navigate(destinations[tab])} />}
        <TicketReturnEditor key={customerReturn?.id || 'new'} customerReturn={customerReturn} shiftId={currentShift?.status === 'OPENED' ? currentShift.id : null} requireShift
            onClose={onClose || (() => navigate(RETOUR_PAGE))}
            onSaved={() => { if (currentShift?.id) dispatch(shiftActions.fetchSummary({ shiftId: currentShift.id })); }} />
    </Container>;
}
